import { render, staticRenderFns } from "./CustomerDetailTab.vue?vue&type=template&id=7e17c7ee&scoped=true"
import script from "./CustomerDetailTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailTab.vue?vue&type=style&index=0&id=7e17c7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e17c7ee",
  null
  
)

export default component.exports